(function () {
  const toggleSelector = '[data-cart-express-toggle]';

  function getPanelForToggle(toggle) {
    const panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return null;
    return document.getElementById(panelId);
  }

  function setExpanded(toggle, panel, expanded) {
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.classList.toggle('is-expanded', expanded);

    if (!panel) return;

    panel.classList.toggle('is-expanded', expanded);
    panel.hidden = !expanded;

    if (expanded) {
      window.requestAnimationFrame(function () {
        panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  function collapseAllExcept(exceptPanel) {
    document.querySelectorAll(toggleSelector).forEach(function (toggle) {
      const panel = getPanelForToggle(toggle);
      if (panel && panel !== exceptPanel) {
        setExpanded(toggle, panel, false);
      }
    });
  }

  function handleToggleClick(event) {
    const toggle = event.target.closest(toggleSelector);
    if (!toggle || toggle.disabled) return;

    const panel = getPanelForToggle(toggle);
    if (!panel) return;

    const willExpand = !panel.classList.contains('is-expanded');
    if (willExpand) {
      collapseAllExcept(panel);
    }
    setExpanded(toggle, panel, willExpand);
  }

  document.addEventListener('click', handleToggleClick);

  document.addEventListener(
    'dialog:open',
    function (event) {
      if (!event.target?.closest?.('cart-drawer-component')) return;
      collapseAllExcept(null);
    },
    true
  );
})();
